import { useHistory } from 'react-router-dom';
import { FunctionalLoader, Page } from 'seagull';
import ImportWizard from "../../components/ImportWizard/ImportWizard";
import { routes } from "../../constants";
import { useStoreActions } from "../../contexts";
import { useActiveServiceTemplates } from "../../hooks/reactQuery/queries/useActiveServiceTemplates";
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
import { useOnMount } from "../../hooks/useOnMount";
import { useServiceTemplateApi } from "../../hooks/useServiceTemplateApi";
import { useSetDocumentTitle } from "../../hooks/useSetDocumentTitle";
import { parseAndValidateServicesCsv } from "./parseAndValidateServicesCsv";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const csvTemplateUrl = 'https://storage.googleapis.com/anchor-statics/Anchor_Import_Services-2023-11-05.zip';
export const csvTemplateUrlWithBundles = 'https://storage.googleapis.com/anchor-statics/Anchor_Import_Services_2025-12-07.zip';
function countServicesAndBundles(items) {
  return items.reduce((acc, item) => {
    if (item.bundle) {
      acc.bundle = (acc.bundle || 0) + 1;
    } else {
      acc.service = (acc.service || 0) + 1;
    }
    return acc;
  }, {});
}
export default function ImportServices() {
  const history = useHistory();
  const {
    data,
    isLoading,
    error
  } = useActiveServiceTemplates({
    refreshOnMount: true
  });
  const {
    fetchServiceTemplates,
    logBI
  } = useStoreActions();
  const serviceTemplateApi = useServiceTemplateApi();
  const {
    UPLOAD_BUNDLES_BULK
  } = useFeatureFlags();
  const title = UPLOAD_BUNDLES_BULK ? 'Import Services and Bundles' : 'Import Services';
  const subheader = UPLOAD_BUNDLES_BULK ? 'Upload a CSV to bring all your existing services and bundles into Anchor.' : 'Import your existing services in bulk in a few simple steps.';
  useSetDocumentTitle(title);
  useOnMount(() => {
    fetchServiceTemplates();
  });
  const gotoServiceLibrary = () => history.push(routes.serviceLibrary);
  if (error) throw error;
  return /*#__PURE__*/_jsxs(Page, {
    header: title,
    subheader: subheader,
    "data-testid": "import-services",
    loading: isLoading,
    onClickBack: gotoServiceLibrary,
    children: [/*#__PURE__*/_jsx(FunctionalLoader, {
      show: !data
    }), /*#__PURE__*/_jsx(ImportWizard, {
      entityName: "services",
      getItemTypeCounts: countServicesAndBundles,
      saveEntityName: "templates",
      importBtnText: "Import",
      csvTemplateUrl: UPLOAD_BUNDLES_BULK ? csvTemplateUrlWithBundles : csvTemplateUrl,
      testid: "import-services",
      parseAndValidateCsv: csvData => parseAndValidateServicesCsv(csvData, data, {
        UPLOAD_BUNDLES_BULK
      }),
      saveItem: serviceTemplateApi.create,
      onEvent: (name, payload) => {
        if (name === 'csvTemplateDownload') {
          logBI(12100);
        } else if (name === 'csvUploaded') {
          logBI(12101, {
            numErrors: payload.badCsv ? 1 : payload.errors.length,
            numRows: payload.items.length
          });
        } else if (name === 'redirectToItems') {
          gotoServiceLibrary();
        } else if (name === 'afterSaveFailure') {
          logBI(12102, {
            success: false
          });
        } else if (name === 'afterSaveSuccess') {
          logBI(12102, {
            success: true
          });
        }
      }
    })]
  });
}